import { type FC, Fragment } from 'react';

import { Icon } from '@vakantiesnl/components/src/atoms/Icon';
import { Typography } from '@vakantiesnl/components/src/atoms/Typography';
import { Flight } from '@vakantiesnl/components/src/molecules/Flight/Flight';
import { useMicroCopyContext } from '@vakantiesnl/services/src/context/microCopyContext';
import { getTimeStringBetweenDates } from '@vakantiesnl/services/src/util/dateUtils';
import { type Search, type Booking } from '@vakantiesnl/types';

import { useStyles } from './FlightTransfer.styles';

type Props = {
	flight: Search.Flight | Booking.Flight;
};

export const FlightTransferSegments: FC<Props> = ({ flight }) => {
	const { classes } = useStyles();
	const microCopies = useMicroCopyContext();

	return (
		<div className={classes.transferFlightSegmentContainer}>
			{flight.flightSegments?.map((flightSegment, i) => {
				const nextFlightSegment = flight.flightSegments?.[i + 1];

				return (
					<Fragment key={i}>
						<Flight microCopies={microCopies} flight={flightSegment} isOutbound={false} isTransfer={true} />
						{nextFlightSegment && (
							<Typography as="h4" variant="labelSm" className={classes.transferTime}>
								<Icon type="time" />
								{getTimeStringBetweenDates(
									new Date(flightSegment.arrivalDateTime),
									new Date(nextFlightSegment.departureDateTime),
								)}{' '}
								{microCopies['common.hours']}
							</Typography>
						)}
					</Fragment>
				);
			})}
		</div>
	);
};
